<template>
  <Flex direction="column">
    <BaseHeading>
      {{ $t('integrations.gifty.settings.locations_title') }}
    </BaseHeading>
    <BaseText>
      {{ $t('integrations.gifty.settings.locations_description') }}
    </BaseText>
    <Flex
      direction="column"
      :gap="0.5"
    >
      <BaseDropdown
        v-for="location in salonLocations"
        :key="location.id"
        v-model="locationMappings[location.id]"
        :label="
          multiLocation
            ? location.internalName || location.name
            : $t('integrations.gifty.settings.location_label')
        "
        :options="options"
        :disabled="disabled"
        v-test="'gifty-location'"
      />
    </Flex>
    <BaseText
      v-if="saveFailed"
      color="error"
      v-test="'gifty-locations-error'"
    >
      {{ $t('integrations.gifty.settings.save_locations_failed') }}
    </BaseText>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { useCompanyStore } from '@/stores/company';
import type { Location } from '@/types';
import type { LocationMappings } from './types';

defineProps<{
  options: { value: string | null; label: string }[];
  salonLocations: Location[];
  saveFailed: boolean;
  disabled: boolean;
}>();

const locationMappings = defineModel<LocationMappings>({ required: true });

const { multiLocation } = useCompanyStore();
</script>
